import * as React from 'react';
import styled from 'styled-components';
import {useLocation} from '@reach/router';
import BlockQuote from './BlockQuote';

export const NavBarLink = ({children, to, light, dropdown, newTab}) => {
    const location = useLocation();
    const isCurrent = location.pathname === to;

    let className = light ? 'white-text' : isCurrent ? 'green-text text-lighten-1' : 'grey-text text-darken-3';
    if (dropdown) className += ' dropdown-trigger';

    return (
        <li>
            <a
                target={newTab ? '_blank' : ''}
                rel={newTab ? 'noreferrer' : ''}
                data-target={dropdown}
                className={className}
                href={to}
            >
                {children}
            </a>
        </li>
    );
};

export const Links = ({light = false, footer = false}) => {
    const aboutId = Math.random().toString();
    const contactId = Math.random().toString();

    // Note: The trailing slash is needed in the "to" field for comparison with the location.pathname in the NavBarLink
    //       component.
    return (
        <>
            {footer || (
                <>
                    <DropdownMenu id={aboutId} className="dropdown-content">
                        <NavBarLink to="/about">About Jodi</NavBarLink>
                        <NavBarLink to="/team">Our Team</NavBarLink>
                        <NavBarLink to="/address">Address</NavBarLink>
                    </DropdownMenu>
                    <DropdownMenu id={contactId} className="dropdown-content">
                        <NavBarLink to="https://p.bttr.to/3AnSXaN" newTab>
                            Book A Free Introductory Call
                        </NavBarLink>
                        <NavBarLink to="mailto:jodi@jodifranklin.com">Email</NavBarLink>
                    </DropdownMenu>
                </>
            )}
            <NavBarLink to="/" light={light}>
                Home
            </NavBarLink>
            {footer ? (
                <>
                    <NavBarLink to="/about" light={light}>
                        About Jodi
                    </NavBarLink>
                    <NavBarLink to="/team" light={light}>
                        Our Team
                    </NavBarLink>
                    <NavBarLink to="/address" light={light}>
                        Address
                    </NavBarLink>
                </>
            ) : (
                <NavBarLink to="#!" light={light} dropdown={aboutId}>
                    About
                </NavBarLink>
            )}
            <NavBarLink to="/happyclients/" light={light}>
                Happy Clients
            </NavBarLink>
            <NavBarLink to="/store/" light={light}>
                Store
            </NavBarLink>
            <NavBarLink to="/links/" light={light}>
                Professional Resources
            </NavBarLink>
            <NavBarLink to="/blog/" light={light}>
                Blog
            </NavBarLink>
            {footer ? (
                <>
                    <NavBarLink to="https://p.bttr.to/3AnSXaN" newTab light={light}>
                        Book A Free Introductory Call
                    </NavBarLink>
                    <NavBarLink to="mailto:jodi@jodifranklin.com" light={light}>
                        Email
                    </NavBarLink>
                    <li>
                        Fax:{' '}
                        <a href="tel:5085001504" className="white-text">
                            (508) 500-1504
                        </a>
                    </li>
                </>
            ) : (
                <NavBarLink to="#!" light={light} dropdown={contactId}>
                    Contact
                </NavBarLink>
            )}
        </>
    );
};

const DropdownMenu = styled.ul`
    width: 260px !important;
`;
